import styled from "styled-components";
import { Stepper } from "@mui/material";
import theme from "../../../styles/theme";

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: 0;
  padding: 28px 48px 28px;
  row-gap: 26px;
  background-color: #ffffff;
  width: 100%;
  border-bottom-style: solid;
  border-color: #e5e7eb;
  border-width: 1px;
  position: relative;

  .brand-row,
  .stepper-shell {
    width: min(100%, 1240px);
    margin: 0 auto;
  }

  .brand-row {
    display: flex;
    align-items: center;
    gap: 28px;
  }

  .subtitle {
    color: #4b5563;
    margin: 0;
    font-family: var(--font-sans);
    font-size: ${theme.fontSize.mm};
    line-height: 1.4;
  }

  .left-image {
    height: 52px;
    object-fit: contain;
    @media ${theme.devices.tablet} {
      height: 60px;
    }
  }

  @media (max-width: 600px) {
    padding: 16px;
    row-gap: 16px;

    .brand-row {
      align-items: flex-start;
      flex-direction: column;
      gap: 8px;
    }

    .subtitle {
      font-size: 13px;
    }
  }
`;

export const LogoutButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  color: #5f6368;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s ease;

  &:hover {
    color: #d93025;
  }

  @media (${theme.devices.tablet}) {
    top: 16px;
    right: 16px;
  }
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #F7F9FC;
  /* height: 100%; */
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 80px;
  .container-data {
    display: flex;
    flex-direction: column;
    font-family: roboto;
    align-items: center;
    text-align: center;
    max-width: 1200px;
    width: 100%;
    margin: 15px auto;
    padding: 0 24px;

    .title {
      font-size: ${theme.fontSize.lg};
      color: black;
      margin-top: 2vh;
      font-weight: 500;
    }
    .subtitle {
      font-size: ${theme.fontSize.mm};
      color: #6b7280;
      margin-top: 4px;
    }

    @media (max-width: 600px) {
      padding: 0 16px;
      margin: 10px auto;

      .title {
        font-size: ${theme.fontSize.mm};
        margin-top: 1.5vh;
      }
      .subtitle {
        font-size: 13px;
        margin-top: 2px;
      }
    }
  }

  /* Estilo especial para etapas com conteúdo técnico */
  &[data-step="0"] .container-data,
  &[data-step="1"] .container-data,
  &[data-step="2"] .container-data {
    align-items: flex-start;
    text-align: left;
  }
`;

export const Footer = styled.div`
  border-top: 1px solid #e6e6e6;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  column-gap: 2vw;
  padding-bottom: 12vh;
  padding-top: 4vh;
`;

export const StyledButton = styled.button<{
  variant?: "primary" | "secondary";
}>`
  font-family: var(--font-sans);
  font-weight: 500;
  font-size: 14px;
  color: white;

  background-color: #1264C7; /* Azul primário do Google */

  padding: 10px 24px;
  border-radius: 8px;
  border: none;

  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #3367d6; /* Tom mais escuro para hover */
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.3);
  }

  &:disabled {
    background-color: #e5e7eb;
    color: #9ca3af;
    cursor: not-allowed;
  }
`;

export const CustomStepper = styled(Stepper)`
  & .MuiStepIcon-root {
    /* Cor do ícone da step ativa */
    &.Mui-active {
      color: #1E8E3E; /* Verde */
    }
    /* Cor do ícone da step completada */
    &.Mui-completed {
      color: #1E8E3E; /* Verde */
    }
  }
`;
export const SecondStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1vh;
  /* Ajuste a largura para acomodar o grid */
  width: auto;
  max-width: 600px; /* Exemplo de largura máxima */
  padding-inline: 15px;
`;

export const ChipGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  gap: 16px;
  justify-content: center;
  width: 100%;
  max-width: 800px;
  align-self: center;
  overflow-y: auto;
  @media ${theme.devices.tablet} {
    grid-template-columns: repeat(1, auto);
    gap: 12px;
  }
  @media (max-width: 600px) {
    grid-template-columns: repeat(2, auto);
    gap: 10px;
    max-width: 90%;
  }
`;

export const TagContainer = styled.div`
  background-color: #fff2cc;
  border-radius: 60px;
  width: fit-content;
  padding: 15px;
  align-self: center;
  margin-top: 2vh;
`;

export const KeywordsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 600px;
  align-self: center;
  margin-top: 2vh;
  gap: 16px;
  padding-inline: 15px;
  @media ${theme.devices.tablet} {
    width: -webkit-fill-available;
    max-width: 90%;
  }
  @media (max-width: 600px) {
    width: -webkit-fill-available;
    max-width: 95%;
    padding-inline: 10px;
    gap: 12px;
  }
`;

export const SelectedChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  width: 100%;
  min-height: 80px;
  @media ${theme.devices.tablet} {
    width: -webkit-fill-available;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
`;

export const SuggestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  margin-bottom: 2vh;
  div {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const SummaryText = styled.p`
  font-family: var(--font-sans);
  font-size: 16px;
  line-height: 1.6;
  color: #2B2D31;
  text-align: left;
  max-width: 700px;
  align-self: center;
  padding: 20px;
  background-color: #F7F9FC;
  border-radius: 8px;
  border: 1px solid #E2E6EA;

  strong {
    font-weight: 700;
    color: #1264C7;
  }
`;

export const DetailsArea = styled.textarea`
  width: 100%;
  max-width: 700px;
  min-height: 250px;
  font-family: var(--font-sans);
  font-size: 16px;
  line-height: 1.6;
  color: #2B2D31;
  background-color: #F7F9FC;
  padding: 20px;
  align-self: center;
  margin-top: 2vh;
  border-radius: 8px;
  border: 1px solid #E2E6EA;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #1264C7;
    box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);
  }

  @media (max-width: 600px) {
    max-width: 95%;
    min-height: 200px;
    padding: 16px;
    font-size: 14px;
    margin-top: 1.5vh;
  }
`;
export const PlansContainer = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  width: 100%;
  align-self: center;
  flex-direction: row;
  box-sizing: border-box;
  @media ${theme.devices.tablet} {
    flex-direction: column;
    margin-bottom: 5vh;
    width: 100%;
    gap: 16px;
    text-align: -webkit-center;
  }
  @media (max-width: 600px) {
    flex-direction: column;
    margin-bottom: 5vh;
    width: 100%;
    padding: 12px;
    gap: 12px;
    text-align: -webkit-center;
  }
`;

export const CampaignText = styled.span`
  align-self: center;
  font-family: Roboto, sans-serif;
  font-size: ${theme.fontSize.mm};
  color: #737373;
  margin-bottom: 3vh;
  text-align: center;
`;

export const SearchContainer = styled.div`
  width: 30%;
  align-self: anchor-center;
  margin-top: 2vh;
  margin-bottom: 2vh;
  @media ${theme.devices.tablet} {
    width: 90%;
  }
  @media (max-width: 600px) {
    width: 90%;
    margin-top: 1.5vh;
    margin-bottom: 1.5vh;
  }
`;

export const FirstStep = styled.div`
  display: flex;
  flex-direction: column;

  .profile-auth-notice {
    width: calc(100% - 48px);
    max-width: 960px;
    margin: 0 auto 18px;
    padding: 14px 16px;
    border: 1px solid #fdd663;
    border-radius: 8px;
    background: #FFF7E0;
    color: #2B2D31;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    font-family: var(--font-sans);
    font-size: 14px;
    line-height: 1.45;
  }

  .profile-auth-notice svg {
    color: #b06000;
    flex: 0 0 auto;
  }

  .profile-auth-notice strong {
    display: block;
    color: #1F1F1F;
    font-size: 14px;
    margin-bottom: 2px;
  }

  .profile-auth-notice button {
    margin-left: auto;
    min-width: 150px;
    border: 0;
    border-radius: 8px;
    background: #1264C7;
    color: #ffffff;
    cursor: pointer;
    font-family: var(--font-sans);
    font-size: 13px;
    font-weight: 700;
    padding: 9px 12px;
  }

  .profile-auth-notice button:hover {
    background: #1558b0;
  }

  @media (max-width: 600px) {
    .profile-auth-notice {
      flex-direction: column;
    }

    .profile-auth-notice button {
      width: 100%;
      margin-left: 0;
    }
  }
`;

export const OnboardingHelp = styled.div`
  width: calc(100% - 48px);
  max-width: 1200px;
  margin: 0 auto 18px;
  padding: 16px 18px;
  border: 1px solid #D6E4F7;
  border-radius: 12px;
  background: #f8fbff;
  color: #2B2D31;
  box-sizing: border-box;

  .eyebrow {
    display: block;
    color: #1264C7;
    font-family: var(--font-sans);
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 4px;
    text-transform: uppercase;
  }

  strong {
    display: block;
    color: #1F1F1F;
    font-family: var(--font-sans);
    font-size: 18px;
    margin-bottom: 4px;
  }

  p {
    margin: 0;
    color: #5f6368;
    font-family: var(--font-sans);
    font-size: 14px;
    line-height: 1.55;
  }

  @media (max-width: 600px) {
    width: calc(100% - 32px);
    padding: 14px;
  }
`;

export const TermsContainer = styled.div`
  width: calc(100% - 48px);
  max-width: 1240px;
  margin: 0 auto 96px;
  padding: 32px;
  border: 1px solid #E2E6EA;
  border-radius: 8px;
  background: #ffffff;
  box-shadow:
    0 1px 3px rgba(60, 64, 67, 0.12),
    0 1px 2px rgba(60, 64, 67, 0.08);
  box-sizing: border-box;
  font-family: var(--font-sans);

  .validation-header {
    padding-bottom: 30px;
  }

  .validation-eyebrow,
  .panel-eyebrow,
  .section-label {
    color: #1264C7;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0;
    text-transform: uppercase;
  }

  .validation-title-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(320px, 380px);
    gap: 24px;
    align-items: center;
    margin-top: 8px;
  }

  h2 {
    margin: 0 0 8px;
    color: #1F1F1F;
    font-size: 28px;
    line-height: 1.2;
  }

  p {
    margin: 0;
    color: #5f6368;
    font-size: 15px;
    line-height: 1.6;
  }

  .google-signal {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 16px;
    border: 1px solid #ceead6;
    border-radius: 8px;
    background: #EAF7EE;
    color: #1E8E3E;
    font-size: 13px;
    font-weight: 700;
  }

  .oauth-card {
    display: grid;
    grid-template-columns: 28px minmax(0, 1fr);
    gap: 10px 12px;
    padding: 16px;
    border: 1px solid #D6E4F7;
    border-radius: 8px;
    background: #f8fbff;
    color: #2B2D31;
  }

  .oauth-card svg {
    color: #1264C7;
    margin-top: 2px;
  }

  .oauth-card span,
  .oauth-card strong {
    display: block;
  }

  .oauth-card strong {
    color: #1F1F1F;
    font-size: 14px;
    margin-bottom: 4px;
  }

  .oauth-card span {
    font-size: 13px;
    line-height: 1.45;
  }

  .oauth-card button {
    grid-column: 1 / -1;
    min-height: 40px;
    border: 0;
    border-radius: 8px;
    background: #1264C7;
    color: #ffffff;
    cursor: pointer;
    font-family: var(--font-sans);
    font-size: 14px;
    font-weight: 700;
  }

  .oauth-card button:hover:not(:disabled) {
    background: #1558b0;
  }

  .oauth-card button:disabled {
    background: #e5e7eb;
    color: #9ca3af;
    cursor: not-allowed;
  }

  .google-signal svg {
    flex: 0 0 auto;
  }

  .trust-strip {
    display: none;
  }

  .validation-layout {
    display: grid;
    grid-template-columns: minmax(320px, 1fr) 1px minmax(320px, 0.92fr);
    gap: 40px;
    margin-top: 14px;
    align-items: stretch;
  }

  .validation-layout::before {
    content: "";
    grid-column: 2;
    grid-row: 1;
    background: #E2E6EA;
    width: 1px;
    min-height: 100%;
  }

  .validation-main,
  .validation-copy {
    border: 0;
    border-radius: 0;
    background: transparent;
    padding: 0;
  }

  .validation-main {
    grid-column: 1;
  }

  .validation-copy {
    grid-column: 3;
    padding-top: 2px;
  }

  .section-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 14px;
  }

  .validation-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 12px;
  }

  .validation-actions button,
  .manual-profile-card {
    font-family: var(--font-sans);
  }

  .validation-actions button {
    border: 1px solid #D6E4F7;
    border-radius: 8px;
    background: #ffffff;
    color: #2B2D31;
    cursor: pointer;
    padding: 12px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-weight: 700;
  }

  .validation-actions button.active {
    border-color: #1264C7;
    background: #EAF1FB;
    color: #0B4FA8;
    box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.12);
  }

  .upload-area {
    display: flex;
    min-height: 220px;
    border: 1px dashed #a8c7fa;
    border-radius: 8px;
    background: #f8fbff;
    overflow: hidden;
    cursor: pointer;
  }

  .upload-area input {
    display: none;
  }

  .upload-area img {
    width: 100%;
    height: 220px;
    object-fit: cover;
  }

  .preview-shell {
    position: relative;
    display: block;
    width: 100%;
  }

  .preview-shell small {
    position: absolute;
    left: 12px;
    bottom: 12px;
    max-width: calc(100% - 24px);
    padding: 6px 10px;
    border-radius: 999px;
    background: rgba(32, 33, 36, 0.82);
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
  }

  .upload-placeholder {
    width: 100%;
    min-height: 220px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #1264C7;
    font-weight: 700;
  }

  .upload-placeholder small,
  .file-name {
    color: #5f6368;
    font-size: 12px;
    font-weight: 500;
  }

  .file-name {
    display: block;
    margin-top: 8px;
    word-break: break-all;
  }

  .upload-footnote {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 18px;
    color: #5f6368;
    font-size: 13px;
    line-height: 1.45;
  }

  .upload-footnote svg {
    color: #1e8e3e;
    flex: 0 0 auto;
  }

  .validation-copy strong {
    display: block;
    color: #1F1F1F;
    font-size: 20px;
    margin-bottom: 12px;
  }

  .checkpoint-list {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0;
    list-style: none;
    margin: 22px 0;
    padding: 0;
  }

  .checkpoint-list li {
    display: grid;
    grid-template-columns: 24px 1fr;
    gap: 14px;
    align-items: flex-start;
    padding: 15px 0;
    border: 0;
    border-bottom: 1px solid #E2E6EA;
    border-radius: 0;
    background: transparent;
    color: #2B2D31;
    font-size: 14px;
    line-height: 1.45;
  }

  .checkpoint-list svg {
    color: #1e8e3e;
    margin-top: 1px;
  }

  .profile-signal {
    display: none;
  }

  .profile-signal svg {
    color: #1264C7;
    flex: 0 0 auto;
  }

  .profile-signal strong,
  .profile-signal small {
    display: block;
  }

  .profile-signal strong {
    margin: 0 0 4px;
    font-size: 14px;
  }

  .profile-signal small {
    color: #5f6368;
    font-size: 13px;
    line-height: 1.45;
  }

  .terms-box {
    margin-top: 32px;
    padding: 18px;
    border: 1px solid #E2E6EA;
    border-radius: 8px;
    background: #ffffff;
    color: #1f2937;
    font-size: 14px;
    line-height: 1.55;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }

  .terms-copy strong {
    display: block;
    margin: 0 0 4px;
    color: #111827;
    font-size: 14px;
  }

  .terms-links {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  a {
    color: #1264C7;
    font-weight: 700;
    text-decoration: none;
  }

  .terms-links a {
    border: 1px solid #aecbfa;
    border-radius: 8px;
    background: #ffffff;
    padding: 8px 12px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .validation-footer-action {
    display: flex;
    justify-content: flex-end;
    margin-top: -40px;
  }

  .validation-footer-action button {
    min-width: 230px;
    min-height: 46px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 700;
    background: #1264C7;
  }

  @media (max-width: 700px) {
    width: calc(100% - 32px);
    padding: 20px;

    .validation-layout,
    .validation-title-row {
      grid-template-columns: 1fr;
    }

    .validation-layout::before {
      display: none;
    }

    .validation-copy {
      grid-column: 1;
      border-top: 1px solid #E2E6EA;
      padding-top: 20px;
    }

    .validation-footer-action {
      margin-top: 16px;
      justify-content: stretch;
    }

    .validation-footer-action button {
      width: 100%;
    }

    .validation-actions {
      grid-template-columns: 1fr;
    }
  }
`;

export const ProfilesContainer = styled.div`
  display: flex;
  gap: 28px;
  justify-content: center;
  margin-top: 16px;
  flex-wrap: wrap;
  overflow-y: auto;
  padding: 10px;
  margin-bottom: 10vh;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  .manual-profile-card {
    min-width: 280px;
    max-width: 360px;
    border: 1px solid #D6E4F7;
    border-radius: 8px;
    background: #f8fbff;
    color: #1F1F1F;
    cursor: pointer;
    padding: 18px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    text-align: left;
    font-family: var(--font-sans);
    box-shadow: 0 8px 24px rgba(60, 64, 67, 0.08);
  }

  .profile-empty-state {
    width: min(100%, 520px);
    margin: 0 auto;
    padding: 24px;
    border: 1px solid #E2E6EA;
    border-radius: 8px;
    background: #ffffff;
    color: #5f6368;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
    font-family: var(--font-sans);
  }

  .profile-empty-state svg {
    color: #1264C7;
    font-size: 28px;
  }

  .profile-empty-state strong {
    color: #1F1F1F;
    font-size: 16px;
  }

  .profile-empty-state span {
    max-width: 420px;
    font-size: 13px;
    line-height: 1.45;
  }

  .manual-profile-card svg {
    color: #1264C7;
    margin-top: 2px;
  }

  .manual-profile-card strong,
  .manual-profile-card small {
    display: block;
  }

  .manual-profile-card strong {
    color: #0B4FA8;
    font-size: 15px;
    margin-bottom: 6px;
  }

  .manual-profile-card small {
    color: #5f6368;
    font-size: 13px;
    line-height: 1.45;
  }

  .manual-profile-card:hover {
    border-color: #1264C7;
    background: #eef5ff;
  }

  @media ${theme.devices.tablet} {
    gap: 16px;
  }
  @media (max-width: 600px) {
    gap: 12px;
    padding: 8px;
    margin-bottom: 1.5vh;
  }
`;
